import { useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Handle, Position } from "reactflow";
import { loadVideoScene, saveGame } from "../../redux/asyncThunk/userActions";
import "reactflow/dist/style.css";
import "../index.css";
import { userSlice } from "../../redux/user/userSlice";
import NodeDeleteContext from "./NodeDeleteContext";
import { sanitizePlainText } from "../../utils/inputValidation";
import {
  getButtonStyle,
  getButtonPosition,
  stripSchemeTransient,
} from "./schemeLayout";
import SchemeSceneContent from "./SchemeSceneContent";
import { useSceneScreenshot } from "./useSceneScreenshot";

const { addMessage } = userSlice;

export function NodeWithToolbar(props) {
  const { data, isConnectable, id } = props;
  const { nodes, edges } = useContext(NodeDeleteContext);
  const [buttonText, setButtonText] = useState("");
  const { hasScreenshot, imageSrc, imageKey, refreshScreenshot } =
    useSceneScreenshot(id, data);

  const dispatch = useDispatch();
  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const game = useSelector((state) => state.user?.game);
  const user = useSelector((state) => state.user?.data?.user);

  const buttonCount = (game?.nodes ?? []).filter(
    (el) => el.id.split("-")[0] === id && el.type === "input"
  ).length;

  const handleVideoChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    dispatch(
      loadVideoScene({
        userId: user.id,
        selectedGameId,
        scene: String(id),
        file,
        game,
      })
    ).then(() => {
      refreshScreenshot();
    });
  };

  const handleAddButtonNode = () => {
    if (!buttonText) {
      return dispatch(
        addMessage({
          type: "error",
          message: "Кнопка не может быть без текста",
        })
      );
    }

    const checkButtonsLength = (game?.nodes ?? []).filter(
      (el) => el.id.split("-")[0] === id && el.type === "input"
    );

    if (checkButtonsLength.length === 2) {
      return dispatch(
        addMessage({
          type: "error",
          message: "Сейчас вы можете добавить только две кнопки",
        })
      );
    }

    const busyPosition =
      checkButtonsLength?.length &&
      checkButtonsLength[0].data.buttonPosiiton === "top"
        ? "bottom"
        : "top";

    const checkButtonsInNode = (game?.nodes ?? []).find(
      (el) => el.id.split("-")[0] === id && el.type === "input"
    );

    const newId = !checkButtonsInNode
      ? `${id}-${Number(id) + 1}`
      : `${id}-${Number(checkButtonsInNode.id.split("-")[1]) + 1}`;

    const newButtonNode = {
      id: newId,
      data: { label: buttonText, buttonPosiiton: busyPosition },
      position: getButtonPosition(busyPosition),
      className: "scheme-button",
      style: getButtonStyle(),
      parentId: `${id}-group`,
      sourcePosition: "right",
      type: "input",
      extent: "parent",
      parentNode: `${id}-group`,
      draggable: false,
    };

    setButtonText("");
    dispatch(
      saveGame({
        selectedGameId,
        nodes: stripSchemeTransient([...nodes, newButtonNode]),
        edges,
      })
    );
  };

  return (
    <>
      <Handle
        type="target"
        position={Position.Left}
        className="scheme-scene__target-handle"
        isConnectable={isConnectable}
      />
      <SchemeSceneContent
        parentGroupId={`${id}-group`}
        hasScreenshot={hasScreenshot}
        imageKey={imageKey}
        imageSrc={imageSrc}
        buttonCount={buttonCount}
        onVideoSelected={handleVideoChange}
        onAddButton={handleAddButtonNode}
        buttonText={buttonText}
        onButtonTextChange={(value) =>
          setButtonText(sanitizePlainText(value, 100))
        }
      />
    </>
  );
}
